<template>
  <form @submit.prevent="onSubmit">
    <div class="input-box">
      <label for="username">
        Name <span>*</span>
      </label>
      <input v-model="formData.name" id="name" type="text" placeholder="Enter Name" />
      <span v-if="errors.name" class="error-message">{{ errors.name }}</span>
    </div>

    <div class="input-box">
      <label for="email">
        Email address <span>*</span>
      </label>
      <input v-model="formData.email" id="email" type="text" placeholder="Enter Email" />
      <span v-if="errors.email" class="error-message">{{ errors.email }}</span>
    </div>

    <div class="input-box">
      <label for="password">
        Password <span>*</span>
      </label>
      <input v-model="formData.password" id="password" type="password" placeholder="Enter password..." />
      <span v-if="errors.password" class="error-message">{{ errors.password }}</span>
    </div>

    <div class="input-box">
      <label for="password_confirmation">
        Re-enter Password <span>*</span>
      </label>
      <input v-model="formData.password_confirmation" id="password_confirmation" type="password"
        placeholder="Re-enter password..." />
      <span v-if="errors.password_confirmation" class="error-message">{{ errors.password_confirmation }}</span>
    </div>

    <div class="login-action mb-10 fix">
      <p>
        Your personal data will be used to support your experience throughout
        this website, to manage access to your account, and for other purposes
        described in our <a href="#">privacy policy</a>.
      </p>
    </div>
    <button type="submit" class="tp-in-btn w-100">Register</button>
  </form>
</template>

<script>
import { toast } from "vue3-toastify";
export default {
  data() {
    return {
      formData: {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
      },
      errors: {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
      },
      loading: false,
    }
  },
  methods: {
    async onSubmit() {
      // Clear previous errors
      this.errors = {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
      }

      // Client-side validation
      if (!this.formData.name) this.errors.name = 'Name is required'
      if (!this.formData.email) {
        this.errors.email = 'Email is required'
      } else if (!/\S+@\S+\.\S+/.test(this.formData.email)) {
        this.errors.email = 'Enter a valid email'
      }
      if (!this.formData.password) {
        this.errors.password = 'Password is required'
      } else if (this.formData.password.length < 6) {
        this.errors.password = 'Password must be at least 6 characters'
      }
      if (this.formData.password !== this.formData.password_confirmation) {
        this.errors.password_confirmation = 'Passwords do not match'
      }

      // Stop if there are validation errors
      if (Object.values(this.errors).some(error => error)) {
        return
      }

      // Send data to the backend
      this.loading = true
      try {
        console.log('Sending data:', this.formData)
        const registerResponse = await this.$axios.post('/register', this.formData)
        toast.success('Registration successful: ' + registerResponse.data.message);

        // Auto-login the user
        const loginResponse = await this.$axios.post('/login', {
          email: this.formData.email,
          password: this.formData.password,
        })

        // Save the token and user data
        const { token, user } = loginResponse.data
        localStorage.setItem('auth_token', token)
        localStorage.setItem('user', JSON.stringify(user))

        // Redirect to my-account page
        window.location.href = '/my-account' // Ensure this matches your route
      } catch (error) {
        console.error(error.response?.data || error.message)
        this.errors = error.response?.data?.errors || { general: 'An error occurred during registration' }
        toast.error(this.errors.general || 'Registration failed');
        
      } finally {
        this.loading = false
      }
    },
    resetForm() {
      this.formData = {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
      }
      this.errors = {}
    },
  },
}
</script>


<style scoped>
.error-message {
  color: red;
  font-size: 12px;
}
</style>
